import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import NavItem from 'react-bootstrap/lib/NavItem'

import FormContainer from './form-container'
// import FormChangeSemester from './form-change-semester'
import { changeSemester, fetchSession } from './actions'

class ChangeSemester extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openModal: false,
    }
  }

  _openModal = () => {
    this.setState({
      openModal: true,
    })
  }

  _closeModal = () => {
    this.setState({
      openModal: false,
    })
  }

  _onSubmit = (input) => {
    const { dispatch } = this.props
    dispatch(changeSemester(input))
    .then((res) => {
      if (!res.error) {
        dispatch(fetchSession())
      }
    })
  }

  render() {
    const { openModal } = this.state
    const { __hardRefresh, session, currentPath } = this.props

    if (__hardRefresh) {
      // hard refresh if sem changes
      window.location.href = currentPath
    }

    return (
      <NavItem onClick={this._openModal}>
        <span className="label label-primary">{session.get('sy')} - {session.get('sem')}</span>
        <FormContainer
          session={session}
          onSubmit={this._onSubmit}
          handleClose={this._closeModal}
          isOpen={openModal}
        />
      </NavItem>
    )
  }
}

ChangeSemester.propTypes = {
  __hardRefresh: PropTypes.bool,
  session: PropTypes.object,
  currentPath: PropTypes.string,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __hardRefresh: state.auth.get('sem_changed'),
  }
}

export default connect(mapStateToProps)(ChangeSemester)



// WEBPACK FOOTER //
// ./src/components/ChangeSemester/index.js